// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";

let options = [
  "MRS",
  "MR",
  "NEUTRAL"
];

function toShortLabel(civility) {
  if (civility === "MR") {
    return I18n.t("Mr.");
  } else if (civility === "MRS") {
    return I18n.t("Mrs.");
  } else {
    return "Mx";
  }
}

function toLongLabel(civility) {
  if (civility === "MR") {
    return I18n.t("Mister");
  } else if (civility === "MRS") {
    return I18n.t("Madam");
  } else {
    return I18n.t("Neutral");
  }
}

export {
  options,
  toShortLabel,
  toLongLabel,
}
/* I18n Not a pure module */
